<template>
  <swiper :options="swiperOption" ref="mySwiper" class="e-assets-slider__wrapper">
    <!-- slides -->
    <transition-group name="fade" tag="swiper-slide" v-if="!$wait.is('assets.fetchAssets')" v-for="asset of myAssets" class="e-assets-slider__item" :key="asset.id">
      <e-asset-card :asset="getAsset(asset)" class="e-assets-slider__container" :key="asset"/>
    </transition-group>

    <transition-group name="fade" tag="swiper-slide" v-if="$wait.is('assets.fetchAssets')" v-for="key in 3" class="e-assets-slider__item" :key="`assets-mock-${key}`">
      <div class="e-asset-card" :key="`assets-mock-${key}`">
        <div class="e-asset-card__header">
          <div class="e-asset-card__header--left">
            <div class="e-asset-card__text eh-primary-text">
              <span class="e-mock e-mock__text float-right"></span>
            </div>
          </div>
          <div class="e-asset-card__header--right">
            <div class="e-asset-card__text eh-secondary-text">
              <span class="e-mock e-mock__text"></span>
            </div>
          </div>
        </div>
        <div class="e-asset-card__content">
          <div class="e-asset-card__logo e-avatar e-mock"></div>
          <p class="e-asset-card__forecast e-mock e-mock__text e-mock--size--small"></p>
        </div>
        <ul class="e-asset-card__list ee-list eh-secondary-text d-none d-xl-flex">
          <li><span class="e-mock e-mock__text e-mock--size--small"></span></li>
          <li><span class="e-mock e-mock__text e-mock--size--small"></span></li>
          <li><span class="e-mock e-mock__text e-mock--size--small"></span></li>
          <li><span class="e-mock e-mock__text e-mock--size--small"></span></li>
          <li><span class="e-mock e-mock__text e-mock--size--small"></span></li>
        </ul>
      </div>
    </transition-group>

    <swiper-slide v-if="myAssets.length <= 3" class="e-assets-slider__item">
      <div class="e-asset-card">
        <div class="e-asset-card__preview">
          <p>Add new Asset in your Watchlist</p>
        </div>
      </div>
    </swiper-slide>

    <div class="e-assets-slider__button e-assets-slider__button--prev swiper-button-prev" slot="button-prev"></div>
    <div class="e-assets-slider__button e-assets-slider__button--next swiper-button-next" slot="button-next"></div>
    <!--<div class="swiper-scrollbar" slot="scrollbar"></div>-->
  </swiper>
</template>

<script>
  import {mapGetters, mapActions, mapState} from 'vuex';
  import EAssetCard from "../../elements/assetCard";

  export default {
		name: "eb-my-assets",
    components: {EAssetCard},
    computed: {
      ...mapGetters('auth', [
        'myAssets',
      ]),
      ...mapGetters('assets', {
        getAsset: 'asset'
      })
    },
    methods: {
      ...mapActions('assets', [
        'fetchAssets'
      ])
    },
    watch: {
      myAssets: {
        handler(current) {
          console.log(current);
          this.fetchAssets(current);
        },
        immediate: true,
      }
    },
    data() {
		  return {
        swiperOption: {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true
          // }
        },
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/myAssets/myAssets.vue